import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  DisplayBoardStatusMap, DisplayBoardStatusTypes, StatusStates,
} from '@powdr/constants';
import { AppContext } from '@powdr/context';
import { getTrails } from '@powdr/stores/actions/trails-action';

import displayBoardMap from './display-board-map';
import { StyledDorDisplayBoard } from './styles';

export const DorDisplayBoard = ({
  board,
}) => {
  const { toggleBodyScroll } = useContext(AppContext);
  const dispatch = useDispatch();
  const useTrailsData = useSelector((state) => state.trails);
  const { isLoading, error, data } = useTrailsData;

  useEffect(() => {
    dispatch(getTrails());
  }, [dispatch]);

  useEffect(() => {
    toggleBodyScroll(true);
    return () => {
      toggleBodyScroll(false);
    };
  }, [toggleBodyScroll]);

  // ERRORS START
  if (error) {
    console.error('DOR Trails API Failed in DOR Display Board:', error.message);
  }

  const getItemStatus = (code, keys) => Object.keys(keys)
    .find((icon, index) => ((Object.values(keys)[index]
      .includes(code))
      ? Object.keys(keys)[index]
      : null));

  return (
    (!isLoading && data) && (
      <StyledDorDisplayBoard id="boards" $board={board}>
        <link href="https://fonts.googleapis.com/css?family=Khula:800" rel="stylesheet" />
        <table className="canvas">
          <tbody>
            {data.map((tr) => {
              const trailData = {
                trailName: displayBoardMap.find(
                  (f) => f.name === tr.name,
                )?.class,
                status: getItemStatus(tr?.status, DisplayBoardStatusMap),
                race: (tr?.properties?.race === true) ? DisplayBoardStatusTypes.RACE : '',
                groomed: (StatusStates.GROOMED.includes(tr?.groom_status)) ? DisplayBoardStatusTypes.GROOMED : '',
              };

              if (trailData.trailName) console.log(trailData.trailName, tr, trailData);

              return (trailData.trailName) ? (
                <tr>
                  <td width="100%" className={`${Object.values(trailData).map((a) => a).join(' ')}`} />
                </tr>
              ) : console.log(tr.name);
            })}
          </tbody>
        </table>
      </StyledDorDisplayBoard>
    )
  );
};

DorDisplayBoard.propTypes = {
  board: PropTypes.string.isRequired,
};
